var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 43,
    viewBox: "0 0 41 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2075_5787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.302 37.2266H4.69802C2.10643 37.2266 0 35.0688 0 32.414V10.5392C0 7.88437 2.10643 5.72656 4.69802 5.72656H36.302C38.8936 5.72656 41 7.88437 41 10.5392V32.414C41 35.0688 38.8936 37.2266 36.302 37.2266ZM4.69802 8.35156C3.52094 8.35156 2.5625 9.33337 2.5625 10.5392V32.414C2.5625 33.6198 3.52094 34.6016 4.69802 34.6016H36.302C37.4791 34.6016 38.4375 33.6198 38.4375 32.414V10.5392C38.4375 9.33337 37.4791 8.35156 36.302 8.35156H4.69802Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 21.4767C10.4583 21.4767 8.54175 19.513 8.54175 17.1018C8.54175 14.6902 10.4583 12.7266 12.8125 12.7266C15.1666 12.7266 17.0832 14.6902 17.0832 17.1018C17.0832 19.513 15.1666 21.4767 12.8125 21.4767ZM12.8125 15.3516C11.8712 15.3516 11.1042 16.1373 11.1042 17.1018C11.1042 18.066 11.8712 18.8517 12.8125 18.8517C13.7537 18.8517 14.5207 18.066 14.5207 17.1018C14.5207 16.1373 13.7537 15.3516 12.8125 15.3516Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 30.2268C18.5115 30.2268 17.9375 29.6388 17.9375 28.9143V28.0392C17.9375 26.8334 16.9791 25.8516 15.802 25.8516H9.82302C8.64594 25.8516 7.6875 26.8334 7.6875 28.0392V28.9143C7.6875 29.6388 7.1135 30.2268 6.40625 30.2268C5.699 30.2268 5.125 29.6388 5.125 28.9143V28.0392C5.125 25.3844 7.23143 23.2266 9.82302 23.2266H15.802C18.3936 23.2266 20.5 25.3844 20.5 28.0392V28.9143C20.5 29.6388 19.926 30.2268 19.2188 30.2268Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5937 16.2266H25.198C24.4907 16.2266 23.9167 15.6386 23.9167 14.9141C23.9167 14.1896 24.4907 13.6016 25.198 13.6016H34.5937C35.301 13.6016 35.875 14.1896 35.875 14.9141C35.875 15.6386 35.301 16.2266 34.5937 16.2266Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5937 23.2266H25.198C24.4907 23.2266 23.9167 22.6386 23.9167 21.9141C23.9167 21.1896 24.4907 20.6016 25.198 20.6016H34.5937C35.301 20.6016 35.875 21.1896 35.875 21.9141C35.875 22.6386 35.301 23.2266 34.5937 23.2266Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5937 30.2266H25.198C24.4907 30.2266 23.9167 29.6386 23.9167 28.9141C23.9167 28.1896 24.4907 27.6016 25.198 27.6016H34.5937C35.301 27.6016 35.875 28.1896 35.875 28.9141C35.875 29.6386 35.301 30.2266 34.5937 30.2266Z",
    fill: "#1996A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2075_5787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 42,
    fill: "white",
    transform: "translate(0 0.476562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCard);
export default __webpack_public_path__ + "static/media/BusinessCard.3f0795845f5be340738cddb3f8d652c0.svg";
export { ForwardRef as ReactComponent };